<template>
  <a-card title="任务管理">
    <p>任务集合，设置之后，列表会展示该集合下的任务</p>
    <a-textarea  v-model:value="preset_ids" :rows="2" placeholder="请输入任务集合 ID，多个 ID 用逗号隔开" />
    <a-form layout="inline" :model="formSearch" style="margin: 10px auto;" >
      <a-form-item>
        <a-input placeholder="任务 ID" v-model:value="formSearch.task_id" />
      </a-form-item>
      <a-form-item>
        <a-input placeholder="用户 ID" v-model:value="formSearch.user_id" />
      </a-form-item>
      <a-form-item  label="任务状态"  name="status">
        <a-select
          :allowClear="true"
          style="width: 100px;"
          v-model:value="formSearch.status"
          :options="statusOptions"
        />
      </a-form-item>
      <a-form-item>
        <a-input  :allowClear="true" placeholder="Queue Name" v-model:value="formSearch.queue_name" />
      </a-form-item>
      <a-form-item>
        <a-input :allowClear="true" style="width: 140px;" placeholder="国家地区" v-model:value="formSearch.region_code" />
        <a-checkbox v-model:checked="formSearch.is_oversea">海外</a-checkbox>
      </a-form-item>
      <a-form-item  label="工具类型"  name="tool_id">
        <a-select
          :allowClear="true"
          show-search
          option-filter-prop="label"
          style="width: 130px;"
          v-model:value="formSearch.tool_id"
          :options="ToolIDOptions"
        />
      </a-form-item>
      <a-form-item  label="任务类型"  name="style_id">
        <a-select
            :allowClear="true"
            show-search
            option-filter-prop="label"
            style="width: 230px;"
          v-model:value="formSearch.style_id"
          :options="TaskStyleGroupOptions"
        />
      </a-form-item>
      <a-form-item   label="任务子类型"  name="sub_type">
        <a-select
          :allowClear="true"
        style="width:140px;"
          v-model:value="formSearch.sub_type"
          :options="SubTypeOptions"
          placeholder="SubType"
        />
      </a-form-item>
      <a-form-item  >
        <a-input placeholder="模板 ID" v-model:value="formSearch.template_id" />
      </a-form-item>
      <a-form-item>
          <a-checkbox v-model:checked="showFirst">仅展示第一条</a-checkbox>
      </a-form-item>
      <a-form-item>
        <a-button
          type="primary"
          html-type="submit"
          @click="handleSearch()"
          shape="circle"
        >
        <template #icon><SearchOutlined /></template>
        </a-button>
      </a-form-item>
    </a-form>
    <div>
      <span>可见内容筛选： </span>
      <div class="local-filter-group" aria-label="本页视图筛选">
        <a-tooltip title="VIP：全部 / 是 / 否">
          <a-button
            class="local-filter-button"
            :class="localFilterClass(formSearch.is_vip)"
            @click="cycleLocalFilter('is_vip')"
          >
            <template #icon><CrownOutlined /></template>
            <span class="local-filter-label">VIP</span>
            <span v-if="formSearch.is_vip !== ''" class="local-filter-state">{{ formSearch.is_vip === 1 ? '是' : '否' }}</span>
          </a-button>
        </a-tooltip>
        <a-tooltip title="内部用户：全部 / 是 / 否">
          <a-button
            class="local-filter-button"
            :class="localFilterClass(formSearch.is_internal)"
            @click="cycleLocalFilter('is_internal')"
          >
            <template #icon><EyeOutlined /></template>
            <span class="local-filter-label">内部用户</span>
            <span v-if="formSearch.is_internal !== ''" class="local-filter-state">{{ formSearch.is_internal === 1 ? '是' : '否' }}</span>
          </a-button>
        </a-tooltip>
        <a-tooltip title="已下载：全部 / 是 / 否">
          <a-button
            class="local-filter-button"
            :class="localFilterClass(formSearch.is_downloaded)"
            @click="cycleLocalFilter('is_downloaded')"
          >
            <template #icon><DownloadOutlined /></template>
            <span class="local-filter-label">已下载</span>
            <span v-if="formSearch.is_downloaded !== ''" class="local-filter-state">{{ formSearch.is_downloaded === 1 ? '是' : '否' }}</span>
          </a-button>
        </a-tooltip>
        <a-tooltip title="继续编辑：全部 / 是 / 否">
          <a-button
            class="local-filter-button"
            :class="localFilterClass(formSearch.is_continued)"
            @click="cycleLocalFilter('is_continued')"
          >
            <template #icon><EditOutlined /></template>
            <span class="local-filter-label">继续编辑</span>
            <span v-if="formSearch.is_continued !== ''" class="local-filter-state">{{ formSearch.is_continued === 1 ? '是' : '否' }}</span>
          </a-button>
        </a-tooltip>
      </div>
    </div>
    <div style="margin: 10px auto;">
      <a-button
        v-if="selectedRowKeys.length > 0"
        type="primary"
        @click="handleBatchAddCase"
        :loading="batchAddLoading"
      >
        批量添加用例 ({{ selectedRowKeys.length }})
      </a-button>
    </div>
    <a-alert :message="noticeMessage" type="info" show-icon style="text-align: left;"  />
      <a-table
    class="ant-table-striped"
    show-quick-jumper
    :row-key="record => record.id"
    :data-source="dataSource"
    :columns="columns"
    :pagination="pagination"
    :loading="loading"
    @change="handleTableChange"
    :row-selection="{
      type: 'checkbox',
      selectedRowKeys: selectedRowKeys,
      onChange: onSelectChange,
      getCheckboxProps: record => ({
        disabled: record.status !== 2
      })
    }"
    :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
    >
      <template #id="{ record }">
      {{ record.id }}
        <a-tag v-if="record.is_first" color="red">First</a-tag>
      </template>
      <template #nickname="{ record }">
        <div style="width: 140px;">Task ID: <a-tag>{{ record.id }}</a-tag></div>
        <div>UID: <a style="cursor: pointer;" @click="handleQueryByUserId(record)">{{ record.user_id }}</a></div>
        <div>昵称: {{ record.nickname ? record.nickname : '-' }}</div>
        <a-tag v-if="record.is_vip" color="red">VIP</a-tag>
        <a-tag v-if="record.is_internal" color="blue">内部</a-tag>
      </template>
      <template #base_img="{ record }">
       <div class="img-thumbnail">
          <div  v-if="record.base_image_key_visible.IsHit"  style="margin:10px 0;">
            <a-button size="small" danger @click="record.base_image_key_visible.IsHit = !record.base_image_key_visible.IsHit">
              <span v-if="record.base_image_key_visible.IsHit">已隐藏 🙈 ({{ record.base_image_key_visible.Confidence }})</span>
              <span v-else>隐藏 🐵</span>
            </a-button>
          </div>
          <template v-else>
            <video
              v-if="/\.(mp4|avi|mov|webm|mkv)$/i.test(record.base_image_file)"
              preload="none"
              poster="http://statica.xuantu.pro/static/upload/20260121_upload_3961633838326165.jpeg"
              :src="rawImage(record.base_image_file)"
              controls
              style="max-width: 200px; max-height: 356px;"
            />
            <a-image
              v-else
              placehoder=false
              style="max-width: 200px; max-height: 356px;"
              :preview='{src: previewImage(record.base_image_file)}'
              :src="thumbnail(record.base_image_file)"
            />
          </template>
       </div>
      </template>
      <template #alter_img="{ record }">
        <div class="img-thumbnail" style="position:relative;">
          <div v-if="record.mask_file && record.style_id != '22'"  style="position:relative;" >
            <img 
              :style="{
                top: 0,
                left: 0,
                position: 'relative',
                opacity:0.2
              }"
              placehoder=false
              :src="thumbnail(record.base_image_file)"
            />
            <img 
              :style="{
                top: 0,
                left: 0,
                'z-index': 1,
                position: 'absolute',
                'mask-image': record.mask_file ? `url(${thumbnail(record.mask_file)})` : '',
                'mask-mode': 'luminance',
              }"
              placehoder=false
              :src="thumbnail(record.base_image_file)"
            />
           
          </div>
        </div>
       
      </template>
      <template #mask_img="{ record }">
        <div class="img-thumbnail">
          <div v-if="record.mask_file"  >
            <img 
              style="max-width: 200px; max-height: 356px;"
              :src="thumbnail(record.mask_file)"
            />
          </div>
        </div>
       
      </template>
      <template #refer_img="{ record }">
        <div class="img-thumbnail">
          <template v-if="record['refer_image_urls'] && record['refer_image_urls'].length > 0">
            <div v-for="(referUrl, idx) in record['refer_image_urls']" :key="'refer-' + idx" style="margin-bottom: 10px;">
              <div v-if="record.refer_image_urls_visible[referUrl] && record.refer_image_urls_visible[referUrl].IsHit" style="margin:10px 0;">
                <a-button size="small" danger @click="record.refer_image_urls_visible[referUrl].IsHit = !record.refer_image_urls_visible[referUrl].IsHit">
                  <span v-if="record.refer_image_urls_visible[referUrl].IsHit">已隐藏 🙈 ({{ record.refer_image_urls_visible[referUrl].Confidence }})</span>
                  <span v-else>隐藏 🐵</span>
                </a-button>
              </div>
              <div v-else>
                <video
                  v-if="referUrl.indexOf('.mp4') > 0"
                  preload="none"
                  poster="http://statica.xuantu.pro/static/upload/20260121_upload_3961633838326165.jpeg"
                  :src="rawImage(referUrl)"
                  controls
                  style="max-width: 200px; max-height: 356px;"
                />
                <a-image
                  v-else
                  placehoder=false
                  style="max-width: 200px; max-height: 356px;"
                  :preview="{src: rawImage(referUrl)}"
                  :src="thumbnail(referUrl)"
                />
              </div>
            </div>
          </template>
          <template v-else-if="record['refer_image_url']">
            <div  v-if="record.refer_image_key_visible.IsHit"  style="margin:10px 0;">
              <a-button size="small" danger @click="record.refer_image_key_visible.IsHit = !record.refer_image_key_visible.IsHit">
                <span v-if="record.refer_image_key_visible.IsHit">已隐藏 🙈 ({{ record.refer_image_key_visible.Confidence }})</span>
                <span v-else>隐藏 🐵</span>
              </a-button>
            </div>
            <div v-else >
               <video
                  v-if="record.refer_image_url.indexOf('.mp4') > 0"
                  preload="none"
                  poster="http://statica.xuantu.pro/static/upload/20260121_upload_3961633838326165.jpeg"
                  :src="rawImage(record.refer_image_url)"
                  controls
                  style="max-width: 200px; max-height: 356px;"
                />
                <a-image
                  v-else
                  placehoder=false
                  :preview="{src: rawImage(record['refer_image_url'])}"
                  :src="thumbnail(record['refer_image_url'])"
                />
            </div>
          </template>

          <a-image
            v-if="record['extra_params'] && record['extra_params']['image'] && record['extra_params']['image']['refer_url']"
            placehoder=false
            style="max-width: 200px; max-height: 356px;"
            :preview="{src: rawImage(record['extra_params']['image']['refer_url'])}"
            :src="thumbnail(record['extra_params']['image']['refer_url'])"
          />
          <a-image
            v-if="(record['sub_type'] == 'replace_hair' || record['sub_type'] == 'replace_hair_omni') && record['extra_params'] && record['extra_params']['value']"
            placehoder=false
            style="max-width: 200px; max-height: 356px;"
            :preview="{src: rawImage(`static/options/hair/${record['extra_params']['value']}.jpg`)}"
            :src="thumbnail(`static/options/hair/${record['extra_params']['value']}.jpg`)"
          />
        </div>
      </template>
      <template #works="{ record }">
        <div v-if="record.works && record.works.length > 0" class="img-thumbnail">
          <a-image-preview-group>
            <div v-for="itm of record.works" :key="itm.id"  style="display: block; margin-bottom:10px;"  >
              <template v-if="/\.(mp4|avi|mov|webm|mkv)$/i.test(itm.works_url)">
                <video
                  preload="none"
                  poster="http://statica.xuantu.pro/static/upload/20260121_upload_3961633838326165.jpeg"
                  :src="rawImage(itm.works_url)"
                  controls
                  style="max-width: 200px; max-height: 356px;"
                />
                <a-tag> (下载: {{ itm.download_total }}, live: {{ itm.live_download_total }})</a-tag>
              </template>
              <template v-else>
                <a-image
                  v-if="itm.visible"
                  style="max-width: 200px; max-height: 356px;"
                  placehoder=false
                  :preview='{src: previewImage(itm.works_url)}'
                  :src="thumbnail(itm.works_url)"
                />
                <div  v-if="itm.sensitive"  style="margin:10px 0;">
                  <a-button size="small" danger @click="itm.visible = !itm.visible">
                    <span v-if="!itm.visible">已隐藏 🙈</span>
                    <span v-else>隐藏 🐵</span>
                  </a-button>
                </div>
              </template>
               
              <div style="margin-top:8px;">
               <a-tag v-if="itm.gen_source" color="#2db7f5" >{{ itm.gen_source }}</a-tag>
                <a-tag v-if="itm.is_reviewed" color="green">已查看</a-tag>
                <a-tag v-if="itm.continual_task_id > 0" color="red">继续编辑(<a style="color:blue;" :href="'/home/creation/works?task_id='+itm.continual_task_id">{{ itm.continual_task_id }}</a>)</a-tag>
                <a-tag> (下载: {{ itm.download_total }}, live: {{ itm.live_download_total }})</a-tag>
                <a-tooltip :title="itm.extend_param ? itm.extend_param.remark : ''">
                  <a-tag v-if="itm.sensitive" color="red">{{ itm.sensitive }}</a-tag>
                </a-tooltip>
              </div>
              <div
                v-if="record.base_image_file && !/\.(mp4|avi|mov|webm|mkv)$/i.test(itm.works_url)"
                style="display: flex; justify-content: center; margin-top: 10px;"
              >
                <TestcaseDiff
                  :origin_image="record.base_image_file"
                  :target_image="itm.works_url"
                  btn_text="结果对比"
                  size="middle"
                  class="work-diff-button"
                />
              </div>
            </div>
          </a-image-preview-group>
          
        </div>
      </template>
      <template #prompt="{ record }">
       <div class="prompt-container"  v-on:click="showBigModel(record)">
        <div>{{ record.prompts }}</div>
        <hr v-if="record.prompts"/>
       <div>{{ record.trans_prompts }}</div>
       </div>
      </template>

      <template #style_title="{ record }">
        <div v-if="record.status == 2 || record.status == 3" >
           <TestcaseAddon :item="{...record, is_task: true}"></TestcaseAddon>
        </div>
        <div>
          <span style="font-weight: bold;">{{ TaskStatus[record.status] }}</span> 
          <span v-if="record.reason">({{ record.reason }})</span>
        </div>
        <div v-if="record.cost" >耗时: {{  record.cost }}s</div>
        create_kind: {{ record.create_kind }} <br/>
        tool_id: {{ record.tool_id }} <br/>
        style_id:  <a-tag>{{ StyleFlowNames[record.style_id] }}</a-tag> <br/>
        sub_type: {{ record.sub_type }} <br/>
        mask_type: <a-tag v-if="record.options == 0 " color="blue">手涂</a-tag>
        <a-tag v-if="record.options == 1 " color="green">自动</a-tag>
        <a-tag v-if="record.options == 2 " >没有</a-tag>
        <br/>
        template_id: {{ record.template_id }} <br/>
        模板名称（后台）：{{ record.template_name }} <br/>
        app_version: <a-tag color="blue">{{ record.app_version }}</a-tag> <br/>
  
        is_deleted: <a-tag v-if="record.is_delete" color="red">已删除</a-tag><span v-else >0</span><br/>
        queue: <a-tag>{{ record.queue_name }}</a-tag> <br/>
        pre_task_id: <span v-if="record.pre_task_id">
           <a :href="'/home/creation/works?task_id='+record.pre_task_id">{{ record.pre_task_id }}</a>
          </span> 
          <span v-else>0</span><br/>
        开始时间： {{ record.task_start_at }} <br/>
        创建时间： {{ record.created_at }} <br/>
        修改时间： {{ record.updated_at }} <br/>
      </template>
      <template #expandedRowRender="{record}">
        <a-table
          :data-source="Object.entries(record).map(([key, value]) => ({ key, value }))"
          :columns="[
            { title: '字段', dataIndex: 'key', key: 'key', width: 200 },
            { title: '值', dataIndex: 'value', key: 'value', customRender: ({ record: row }) => {
                  if (row.key === 'extra_params' || row.key === 'works') {
                    return h('pre', { style: { margin: 0 } }, JSON.stringify(row.value, null, 2))
                  } else {
                    return row.value
                  }
                }
              }
          ]"
          :pagination="false"
          size="small"
          bordered
        />
      </template>
      <template #task_start_at="{ record }">
        开始时间： {{ record.task_start_at }} <br/>
        创建时间： {{ record.created_at }}
      </template>
    </a-table>
    
  </a-card>

  <!-- 批量添加用例标签选择对话框 -->
  <a-modal
    title="批量添加用例"
    v-model:visible="batchLabelModalVisible"
    @ok="handleBatchAddCaseConfirm"
    @cancel="batchLabelModalVisible = false"
    :confirm-loading="batchAddLoading"
    width="600px"
  >
    <div style="margin-bottom: 16px;">
      <p>将为选中的 <strong>{{ selectedRowKeys.length }}</strong> 个任务创建测试用例</p>
    </div>
    <a-form-item label="用例标签">
      <a-spin :spinning="labelLoading" tip="加载标签中...">
        <a-checkbox-group
          v-model:value="selectedLabels"
          :options="labelOptions"
        />
        <TestcaseLabelCreate
          size="small"
          style="margin: 4px;"
          @ok="getLabels"
          :record="{}"
        />
      </a-spin>
    </a-form-item>
  </a-modal>

  <!-- <UserEditor v-model:visible="userEditorVisible" @cancle="userEditorVisible=false" /> -->

</template>
<script>
import { defineComponent,  h,onMounted} from 'vue'
import { Modal, message } from 'ant-design-vue';

import { SearchOutlined, EyeOutlined, DownloadOutlined, EditOutlined, CrownOutlined } from '@ant-design/icons-vue';
import request from '@/utils/request'
import store from '@/store'
import {useRoute} from 'vue-router'
import TestcaseAddon from '@/components/TestcaseAddon.vue'
import TestcaseLabelCreate from '@/components/TestcaseLabelCreate.vue'
import TestcaseDiff from '@/components/TestcaseDiff.vue'
import { StyleFlowNames, TaskStyleGroupOptions,SubTypeOptions, ToolIDOptions} from '@/utils/macro'
import {thumbnail , rawImage} from '@/utils/image'
// 0排队中 1创作中 2创作完成 3创作失败
const TaskStatus = {
  0: "🚗 排队中..",
  1: "🚀 创作中.. ",
  2: "✅ 创作完成 ",
  3: "❌ 创作失败 ",
}


export default defineComponent({
  components: {
    SearchOutlined,
    CrownOutlined,
    EyeOutlined,
    DownloadOutlined,
    EditOutlined,
    TestcaseAddon,
    TestcaseLabelCreate,
    TestcaseDiff,
  },
  data(){
    return {
      loading: false,
      dataSource: [],
      rawDataSource: [],
      pageNo: 0,
      StyleFlowNames,TaskStyleGroupOptions,
      ToolIDOptions,
      preset_ids:"",
      SubTypeOptions:  SubTypeOptions,
      showFirst: false,
      selectedRowKeys: [],
      selectedRows: [],
      batchAddLoading: false,
      batchLabelModalVisible: false,
      labelLoading: false,
      selectedLabels: [],
      labelOptions: [],
      statusOptions: [{
          label: "所有", value: '',
        },
        {
          label: "排队中", value: 0
        }, {
          label: "执行中", value: 1
        }, {
          label: "执行成功", value: 2
        }, {
          label: "执行失败", value: 3
        }, {
          label: "执行退出", value: 4
        }
      ],
      pagination: {
        total: 1,
        current: 0,
        pageSize: 20,
        'show-quick-jumper': true,
        'show-size-changer': true,
        pageSizeOptions: ['20', '50', '100']
      },
      noticeMessage: '性能问题，总条数不再展示',

       formSearch: {
        is_oversea: false,
        template_id: '',
        tool_id: '',
        style_id: '',
        sub_type: '',
        status: '',
        user_id: '',
        task_id: '',
        queue_name: '',
        region_code: '',
        is_internal: '',
        is_vip: '',
        is_downloaded: '',
        is_continued: '',
      },

      uploadLoading: false,
    }
  },
  mounted(){
    const route = useRoute()
    if (route.query['task_id']) {
      this.formSearch.task_id = route.query['task_id']
    }
    if (route.query['user_id']) {
      this.formSearch.user_id = route.query['user_id']
    }
    if (route.query['queue_name']) {
      this.formSearch.queue_name = route.query['queue_name']
    }
    for (const field of ['template_id', 'tool_id', 'style_id']) {
      const value = route.query[field]
      if (typeof value === 'string') {
        this.formSearch[field] = value
      }
    }

    this.handleTableChange()
  },
  computed:{
    user_id : () => {
      if (store) {
        return store.state.user.user_id
      }
      
    }, 
    nickname : () => {
      if (store) {
        return `${store.state.user.nickname}-${store.state.user.user_id}`
      }
      
    },
  },
  methods: {
    handleQueryByUserId(record) {
      this.formSearch.user_id = record.user_id
      this.handleSearch()
    },
    handleSearch() {
      // 搜索时清空选择（因为数据集变了）
      this.selectedRowKeys = []
      this.selectedRows = []
      this.handleTableChange()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      // 获取当前页的所有任务ID
      const currentPageIds = this.dataSource.map(item => item.id)

      // 移除当前页原本选中的任务
      this.selectedRowKeys = this.selectedRowKeys.filter(id => !currentPageIds.includes(id))
      this.selectedRows = this.selectedRows.filter(row => !currentPageIds.includes(row.id))

      // 添加当前页新选中的任务
      this.selectedRowKeys.push(...selectedRowKeys)
      this.selectedRows.push(...selectedRows)
    },
    handleBatchAddCase() {
      if (this.selectedRowKeys.length === 0) {
        message.warning('请先选择任务')
        return
      }
      // 显示标签选择对话框
      this.selectedLabels = []
      this.getLabels()
      this.batchLabelModalVisible = true
    },
    getLabels(){
      this.labelLoading = true
      request.get(`/api/testcase/labels/`, {
        category: "打标",
        limit: 200,
      }).then((rsp) => {
        if (rsp.code == 0) {
          this.labelOptions = rsp.data.list.map((item) => {
            return {
              label: item.name,
              value: item.id,
            }
          })
        } else {
          message.error(rsp.msg)
        }
      }).catch((err) => {
        message.error(err.message)
      }).finally(() => {
        this.labelLoading = false
      })
    },
    async handleBatchAddCaseConfirm() {
      this.batchLabelModalVisible = false
      this.batchAddLoading = true
      let successCount = 0
      let failCount = 0
      const errors = []

      const labels = this.selectedLabels.join(',')

      for (const row of this.selectedRows) {
        try {
          // 构造用例数据，类似 TestcaseAddon 组件的逻辑
          const caseData = {
            case_name: `${this.StyleFlowNames[row.style_id]}#${row.id}`,
            task_id: `${row.id}`,
            style_id: row.style_id,
            tool_id: row.tool_id,
            mask_type: row.options == 0 ? 'selfdefined' : 'default',
            prompt: row.trans_prompts || row.prompts,
            base_image_key: row.base_image_file,
            mask_image_key: row.mask_image_key || '',
            refer_image_key: row.refer_image_key || row.refer_image_url || '',
            work_image_key: row.work_image_key || '',
            work_id: row.works && row.works.length > 0 ? row.works[0].id : '',
            template_id: row.template_id || '',
            extra_params: row.extra_params ? JSON.stringify(row.extra_params) : '',
            labels: labels,
          }

          const rsp = await request.post(`/api/testcase/cases/task`, caseData)
          if (rsp.code === 0) {
            successCount++
          } else {
            failCount++
            errors.push(`任务${row.id}: ${rsp.msg}`)
          }
        } catch (err) {
          failCount++
          errors.push(`任务${row.id}: ${err.message}`)
        }
      }

      this.batchAddLoading = false

      if (failCount === 0) {
        message.success(`成功添加 ${successCount} 个用例`)
      } else {
        Modal.warning({
          title: '批量添加完成',
          content: `成功: ${successCount} 个, 失败: ${failCount} 个\n${errors.length > 0 ? '\n失败原因:\n' + errors.join('\n') : ''}`,
        })
      }

      // 清空选择
      this.selectedRowKeys = []
      this.selectedRows = []
    },
    showBigModel(record){
      Modal.info({
        title: 'Prompts',
        maskClosable: true,
        content: () => h('div', {}, [
          h('div', {}, `Prompt: ${record.prompts}`),
          h('hr'),
          h('div', {}, `翻译: ${record.trans_prompts}`)
        ]),
        okText: '复制 Prompt',
        onOk() {
            // 将 record.prompts 复制到剪切板
            navigator.clipboard.writeText(record.prompts)
              .then(() => {
                message.success('复制成功');
              })
              .catch(() => {
                message.error('复制失败');
              });
          },
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onCancel() {},
      })

    },
    thumbnail,
    rawImage,
    previewImage(url) {
      // HEIC 不能被多数浏览器直接预览。预览只转码，不缩放，保留原图尺寸。
      if (!/\.hei[cf](?:$|[?#])/i.test(url || '')) {
        return rawImage(url)
      }
      const originalUrl = rawImage(url).split('?')[0]
      return `${originalUrl}?x-oss-process=image/auto-orient,1/format,jpg`
    },
    cycleLocalFilter(field) {
      const currentValue = this.formSearch[field]
      this.formSearch[field] = currentValue === '' ? 1 : currentValue === 1 ? 0 : ''
      this.applyLocalFilters()
    },
    localFilterClass(value) {
      if (value === 1) return 'is-include'
      if (value === 0) return 'is-exclude'
      return 'is-all'
    },
    applyLocalFilters() {
      this.dataSource = this.rawDataSource.filter((item) => {
        const works = Array.isArray(item.works) ? item.works : []
        const isVip = item.is_vip === true || Number(item.is_vip) === 1
        const isVipMatch = this.formSearch.is_vip === '' || isVip === (this.formSearch.is_vip === 1)
        const isInternalUser = item.is_internal === true || Number(item.is_internal) === 1
        const isInternalMatch = this.formSearch.is_internal === '' || isInternalUser === (this.formSearch.is_internal === 1)
        const hasDownloaded = works.some((work) => Number(work.download_total) > 0 || Number(work.live_download_total) > 0)
        const isDownloadedMatch = this.formSearch.is_downloaded === '' || hasDownloaded === (this.formSearch.is_downloaded === 1)
        const hasContinued = works.some((work) => Number(work.continual_task_id) > 0)
        const isContinuedMatch = this.formSearch.is_continued === '' || hasContinued === (this.formSearch.is_continued === 1)
        return isVipMatch && isInternalMatch && isDownloadedMatch && isContinuedMatch
      })
    },
    async handleTableChange (pagi = {pageSize: 20, current: 1}) {
      if (this.formSearch.template_id > 0 && this.formSearch.style_id == '') {
        message.error("筛选模板的时候，需要同时筛选任务类型")
        return
      }
     
      this.preset_ids = this.preset_ids.replaceAll('"', '')
      this.preset_ids = this.preset_ids.replaceAll("\n", ',')
      let limit = pagi.pageSize
      let orderBy = "id desc"
      if (this.showFirst) {
        limit = 1
        orderBy = "id asc"
      }
      if (this.formSearch.is_oversea) {
        this.formSearch.region_code = 'OVERSEA'
      }
      let ids = ""
      let offset =  (pagi.current - 1) * pagi.pageSize
      let mockTotal = 0
      if (this.preset_ids != "") {
        let pageIDs = this.preset_ids.split(",")
        mockTotal = pageIDs.length
        // 从 pageIDs 翻页
        if (pagi.current >= 1) {
          pageIDs = pageIDs.slice((pagi.current - 1) * pagi.pageSize, pagi.current * pagi.pageSize)
        }
        ids = pageIDs.join(",")
        offset = 0
        this.formSearch.ids = ids
        
      }
      const serverSearchParams = { ...this.formSearch }
      delete serverSearchParams.is_internal
      delete serverSearchParams.is_vip
      delete serverSearchParams.is_downloaded
      delete serverSearchParams.is_continued
      const searchParams = {
        offset: offset,
        limit: limit,
        order_by: orderBy,
        ...serverSearchParams,
        // after_cursor: afterCursor,
        // before_cursor: beforeCursor,
      }
      this.loading = true
      const rsp = await request.get('/api/creation/works', searchParams)
      if (mockTotal > 0 && rsp.data.pagination) {
        rsp.data.pagination.total = mockTotal
      }
      this.loading = false
      this.dataSource = [].concat(rsp.data.list)
      for(let i in this.dataSource) {
        let item = this.dataSource[i]
        if (!item.image_antis) {
          item.image_antis = {}
        }
        item.base_image_key_visible = {}
        item.refer_image_key_visible = {}
        item.refer_image_urls_visible = {}
        if (item.image_antis[item.base_image_key]) {
          item.base_image_key_visible = item.image_antis[item.base_image_key]
        }
        if (item.image_antis[item.refer_image_key]) {
          item.refer_image_key_visible = item.image_antis[item.refer_image_key]
        }
        if (item.refer_image_urls && item.refer_image_urls.length > 0) {
          for(let j in item.refer_image_urls) {
            let url = item.refer_image_urls[j]
            if (item.image_antis[url]) {
              item.refer_image_urls_visible[url] = item.image_antis[url]
            }
          }
        }
        if (item.extra_params != "") {
          item.extra_params = JSON.parse(item.extra_params)
          if(item.extra_params["userdefined"]) {
            item.refer_image_url = item.extra_params["userdefined"]
            item.refer_image_url = item.refer_image_url.replace("http://statica.xuantu.pro/", "")

          }
          if(item.extra_params["croped_face"]) {
            item.mask_file = item.extra_params["croped_face"]
            item.mask_file = item.mask_file.replace("http://statica.xuantu.pro/", "")
          }
          item.created_at = new Date(item.created_at).toLocaleString()
          item.updated_at = new Date(item.updated_at).toLocaleString()
        } 
        if (item['refer_image_key']) {
          item['refer_image_url'] = item['refer_image_key']
        }
        item.mask_image_key = item.mask_file
        if (item.works && item.works.length > 0) {
          item.work_image_key = item.works[0]["works_url"]
          for (let j in item.works) {
            item.works[j]['visible'] = true
            if (item.works[j]['extend_param']) {
              item.works[j]['extend_param'] = JSON.parse(item.works[j]['extend_param'])
              if (item.works[j]['extend_param'] && item.works[j]['extend_param'].remark && item.works[j]['extend_param'].remark.indexOf('pornographic_adultContent') > -1) {
                item.works[j]['visible'] = false
                item.works[j]['sensitive'] = '高敏感'
              }
            }
          }
        }
        
        this.dataSource[i] = item
      }
      this.rawDataSource = this.dataSource
      this.applyLocalFilters()
      if (rsp.data.pagination.total < 23979272) {
        this.noticeMessage = `共 ${rsp.data.pagination.total} 条`
      }
      let total = rsp.data.pagination.total
      this.pagination.total = total
      this.pagination.current = pagi.current
      this.pagination.pageSize = pagi.pageSize
    },
    
  },
  setup(props, context) {
   
    return {
    h,
      TaskStatus,
      uploadInput: null,
      columns: [
      // {
      //     title: 'Task ID',
      //     dataIndex: 'id',
      //     key: 'id',
      //     slots: { customRender: 'id' },
      //   },
        {
          title: '标识',
          dataIndex: 'nickname',
          key: 'nickname',
          slots: { customRender: 'nickname' },
        },
        {
          title: '原图',
          dataIndex: 'base_img',
          key: 'base_img',
          slots: { customRender: 'base_img' },
        },
        {
          title: 'Mask',
          dataIndex: 'mask_img',
          key: 'mask_img',
          slots: { customRender: 'mask_img' },
        },
        {
          title: '融合',
          dataIndex: 'alter_img',
          key: 'alter_img',
          slots: { customRender: 'alter_img' },
        },
 
        {
          title: '垫图',
          dataIndex: 'refer_img',
          key: 'refer_img',
          slots: { customRender: 'refer_img' },
        },
       
        // {
        //   title: '作品类型',
        //   dataIndex: 'create_kind',
        //   key: 'create_kind',
        // },
        // {
        //   title: '工具类型',
        //   dataIndex: 'create_tool',
        //   key: 'create_tool',
        // },
      
        {
          title: '作品',
          dataIndex: 'works',
          key: 'works',
          slots: { customRender: 'works' },
        },
         {
          title: 'Prompt',
          dataIndex: 'prompt',
          key: 'prompt',
          slots: { customRender: 'prompt' },
        },
        // {
        //   title: '状态',
        //   dataIndex: 'status',
        //   key: 'status',
        //   slots: { customRender: 'status' },
        // },
          {
          title: '信息',
          dataIndex: 'style_title',
          key: 'style_title',
          slots: { customRender: 'style_title' },
        },
        // {
        //   title: '耗时',
        //   dataIndex: 'cost',
        //   key: 'cost',
        // },
        // {
        //   title: '任务开始时间',
        //   dataIndex: 'task_start_at',
        //   key: 'task_start_at',
        //   slots: { customRender: 'task_start_at' },
        // },
       
      ],
    };
  },
})
</script>

<style scoped>
.ant-table-striped :deep(.table-striped) td {
  background-color: #fafafa;
}
.img-thumbnail {
  /* max-height: 355px; */
  width: 200px;
  overflow-y: scroll;
}
.thumbnail-wraps {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.prompt-container {
  cursor: pointer;
  max-height: 350px;
  max-width: 100px;
  overflow-y: scroll;
}
.prompt-container:hover {
  color: red;
}
.local-filter-item :deep(.ant-form-item-control-input-content) {
  display: flex;
}
.local-filter-group {
  display: inline-flex;
  overflow: hidden;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  background: #fff;
}
.local-filter-button {
  position: relative;
  height: 32px;
  padding: 0 10px;
  border: 0;
  border-right: 1px solid #f0f0f0;
  border-radius: 0;
  color: #595959;
  box-shadow: none;
}
.local-filter-button:last-child {
  border-right: 0;
}
.local-filter-button:hover {
  color: #1677ff;
  background: #f0f7ff;
}
.local-filter-button.is-include {
  color: #1677ff;
  background: #e6f4ff;
}
.local-filter-button.is-exclude {
  color: #cf1322;
  background: #fff1f0;
}
.local-filter-label {
  margin-left: 4px;
}
.local-filter-state {
  margin-left: 4px;
  font-size: 11px;
  font-weight: 600;
}
.work-diff-button :deep(.ant-btn) {
  font-weight: 600;
  padding: 0 18px;
  box-shadow: 0 2px 6px rgb(24 144 255 / 35%);
}
</style>
